module.exports = __webpack_public_path__ + "img/chat-unread.aaa820e1.svg";